import { FunctionComponent, ReactNode } from "react";
import {
  ToastMessageProps,
  TOAST_STATUS,
} from "@leagueplatform/toast-messages";
import { FormattedHTMLMessage } from "@leagueplatform/locales";

import {
  GDSStatus,
  StackItem,
  StackLayout,
  StatusBanner,
  HeadingText,
  ParagraphText,
} from "@leagueplatform/genesis-core";
import { LocalesKey } from "types/types";

const StatusBannerMap: Record<TOAST_STATUS, GDSStatus> = {
  success: "success",
  warning: "warning",
  error: "error",
  note: "neutral",
  attention: "warning",
  info: "info",
  inverted: "brand",
};

export const CustomToastMessage: FunctionComponent<ToastMessageProps> = ({
  type,
  text,
  dismiss,
  messageId,
  textId,
  content,
  contentId,
  values,
}) => (
  <StackLayout orientation="horizontal" horizontalAlignment="end">
    <StackItem
      css={{
        position: "relative",
        pointerEvents: "auto",
        cursor: "pointer",
        width: "40rem",
      }}
    >
      <StatusBanner
        status={StatusBannerMap[type]}
        title={
          // eslint-disable-next-line no-nested-ternary
          text || textId ? (
            textId ? (
              <HeadingText level="display" size="sm">
                {/* eslint-disable-next-line @leagueplatform/literal-i18n-message-id  */}
                <FormattedHTMLMessage
                  id={textId as LocalesKey}
                  values={values}
                />
              </HeadingText>
            ) : (
              text
            )
          ) : null
        }
        onDismissClick={() => dismiss(messageId)}
        aria-live="polite"
        css={{
          borderRadius: "$extraLarge",
          alignItems: "start",
          ".GDS-status-banner-dismiss-button": {
            backgroundColor: "transparent",
            color: "$onSurfaceTextSubdued",
            width: "24px",
            height: "24px",
            "& svg": {
              width: "12px",
              height: "12px",
            },
          },
        }}
      >
        {
          // eslint-disable-next-line no-nested-ternary
          content || contentId ? (
            contentId ? (
              <ParagraphText
                css={{ typography: "$bodyTwo", marginBlockStart: "$quarter" }}
              >
                {/* eslint-disable-next-line @leagueplatform/literal-i18n-message-id */}
                <FormattedHTMLMessage
                  id={contentId as LocalesKey}
                  values={values}
                />
              </ParagraphText>
            ) : (
              (content as ReactNode)
            )
          ) : null
        }
      </StatusBanner>
    </StackItem>
  </StackLayout>
);
